import React, { useEffect, useState } from 'react';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { connect, ConnectedProps, useDispatch } from 'react-redux';
import store from './redux/store';
import HomePage from './pages/HomePage';
import UsuarioPage from './pages/UsuarioPage';
import CodePage from './pages/CodePage';
import PasswordPage from './pages/PasswordPage';
import ReferralPage from './pages/ReferralPage';
import AdminPage from './pages/AdminPage';
import ScoutingPoolPage from './pages/ScoutingPoolPage';
import GetpremiumPage from './pages/GetpremiumPage';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import './App.css';
import LoginPage from './pages/LoginPage';
import InvoicesPage from './pages/InvoicesPage';
import CompaniesPage from './pages/CompaniesPage';
import EmpresaPerfilPage from './pages/EmpresaPerfilPage';
import UsuariosPage from './pages/UsuariosPage';
import AccountPage from './pages/AccountPage';
import ScoutMePage from './pages/ScoutMePage';
import JobboardPage from './pages/JobboardPage';
import JobboardAdmPage from './pages/JobboardAdmPage';
import AiVisaGuidePage from './pages/AiVisaGuidePage';
import AiInterviewSimulation from './pages/AiInterviewSimulation';
import AiResumeFeedback from './pages/AiResumeFeedback';
import ProdutosPage from './pages/ProdutosPage';
import ScoutersPage from './pages/ScoutersPage';
import ScoutPage from './pages/ScoutPage';
import CarrerGuidePage from './pages/CarrerGuidePage';
import CategoriasPage from './pages/CategoriesPage';
import LogsPage from './pages/LogsPage';
import SignUpPage from './pages/SignUpPage';
import MapaPage from './pages/MapaPage';
import LocationPage from './pages/LocationPage';
import FavoritesPage from './pages/FavoritesPage';
import DashboardPage from './pages/Dashboard';
import NotificationsPage from './pages/NotificationsPage';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import { updateUserPosition } from './redux/user/actions';
import { getProdutos, getProdutosByCategory } from './redux/produtos/actions';
import { socket } from './socket';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { Admin, Resource } from 'react-admin';
import Drawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import MenuIcon from '@mui/icons-material/Menu';
import Badge from '@mui/icons-material/Badge';
import NotificationsIcon from '@mui/icons-material/Notifications';
import SearchIcon from '@mui/icons-material/Search';
import MoreIcon from '@mui/icons-material/MoreVert';
import List from '@material-ui/core/List';
import Divider from '@mui/material/Divider';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { Button } from '@mui/material';
import { toggleDrawerStart } from './redux/global/actions';
import bg from "./assets/images/bg.png"
import WaitListPage from './pages/WaitListPage';
import { findProfileByUser, whoami } from './graphqlClient/graphql';
import { loginSuccess, logout } from './redux/auth/actions';
import { setUser, } from './redux/user/actions';
import { serverConfig } from './api/apiConfig';
import { setImageProfile } from './redux/usuarios/actions';
import { ChatProvider } from './components/Chat/ChatContext';
import ChatFloatingButton from './components/Chat/ChatFloatingButton';
import ChatList from './components/Chat/ChatList';
import ChatWindow from './components/Chat/ChatWindow';
type PropsFromRedux = ConnectedProps<typeof connector>;



const App: React.FC<PropsFromRedux> = ({ isLogged, setImageProfile, user, setUser, updateUserPosition }) => {
  //function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const { hash, pathname, search } = location;
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const toggleDrawer = () => {
    //setOpen(!open);
    dispatch(toggleDrawerStart())
  };
  const [isConnected, setIsConnected] = useState(socket.connected);
  const [fooEvents, setFooEvents] = useState<any>([]);
  //

  //
  /* const client = new ApolloClient({
    uri: 'http://localhost:3000/graphql',
    cache: new InMemoryCache(),
  }); */
  //
  /* client
  .query({
    query: gql`
      query getUsers{users{name, email, _id}}
    `,
  })
  .then((result) => console.log(result)); */
  const createNotification = (type: any) => {
    console.log('createnotification', type)

    switch (type) {
      case 'info':
        NotificationManager.info('Info message');
        break;
      case 'success':
        NotificationManager.success('Success message', 'Greentag');
        break;
      case 'warning':
        NotificationManager.warning('Warning message', 'Close after 3000ms', 3000);
        break;
      case 'error':
        NotificationManager.error('Error message', 'Click me!', 5000, () => {
          alert('callback');
        });
        break;

    };
  }

  const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop: any) => prop !== 'open',
  })
    <{
      open?: boolean;
    }>
    (({ theme, open }) => ({
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
      }),
    }));

  const getProfileByUserAsync = async (userId: any) => {

    try {
      const profile: any = await findProfileByUser(userId);
      console.log('profile ==>>', profile)
      if (!profile) {
        return false;
        //setHasProfile(false)
      } else {
        return profile;
        //setHasProfile(true)

      }


    }
    catch (error) {
      console.log("Erro no getUser >>>>>", error)
    }

  }

  const getUser = async () => {
    try {
      const user: any = await whoami();
      console.log('user ==>>', user);
      return user;
    } catch (error) {
      console.log("Erro no getUser >>>>>", error);
      return null;
    }
  };

  const checkPath = async () => {
    const token = localStorage.getItem('token') || localStorage.getItem('AUTH_USER_TOKEN_KEY');
    const publicPaths = ['/login', '/password', '/referral', '/signup', '/signup/scout', '/signup/scouter', '/signup/scoutme'];
    const isPublicPath = publicPaths.includes(pathname) || pathname.startsWith('/signup/');

    if (!isLogged && pathname !== '/login') {
      if (!token) {
        if (!isPublicPath) {
          navigate('/login');
        }
        return false;
      }

      const loggedUser: any = await getUser();
      if (loggedUser?.image) {
        const imagePath = serverConfig.dev.url + 'images/' + loggedUser.image;
        setImageProfile(imagePath);
        console.log('configurou o image profile');
      }

      if (loggedUser?.name && loggedUser?._id) {
        const newUser: any = { ...loggedUser };
        try {
          const profile = await getProfileByUserAsync(loggedUser._id);
          if (profile?.pdf) {
            newUser.pdf = profile.pdf;
          }
        } catch (e) {
          console.warn('Error fetching profile pdf:', e);
        }
        console.log('logged user ===> ', newUser);
        setUser(newUser);
        dispatch(loginSuccess(newUser));
        return true;
      } else {
        // Token invalid or session expired on server
        localStorage.removeItem('token');
        localStorage.removeItem('AUTH_USER_TOKEN_KEY');
        localStorage.removeItem('AUTH_USER_RENEW_TOKEN_KEY');
        localStorage.removeItem('loginData');
        localStorage.removeItem('jwt');

        if (!isPublicPath) {
          navigate('/login');
        }
        return false;
      }
    }

    if (!isLogged && pathname === '/password') {
      navigate('/password' + search);
    } else if (!isLogged && pathname === '/referral') {
      navigate('/referral' + search);
    } else if (!isLogged && (pathname === '/signup' || pathname === '/signup/')) {
      navigate('/signup/scout' + search);
    } else if (!isLogged && (pathname === '/signup/scout' || pathname === '/signup/scoutme')) {
      navigate('/signup/scout' + search);
    } else if (!isLogged && pathname === '/signup/scouter') {
      navigate('/signup/scouter' + search);
    } else if (isLogged && !user?.confirmed) {
      navigate('/code');
    } else if (isLogged && user?.role === "scout" && pathname === '/login') {
      navigate('/scout');
    } else if (isLogged && user?.role === "scouter" && pathname === '/login') {
      navigate('/scouter');
    } else if (isLogged && pathname === '/login') {
      navigate('/');
    } else if (!isLogged && !isPublicPath) {
      navigate('/login');
    }
  };

  useEffect(() => {
    checkPath();
  }, [isLogged, pathname]);

  // Synchronize logout across browser tabs
  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'token' && !e.newValue) {
        (dispatch as any)(logout());
        navigate('/login');
      }
    };
    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [dispatch, navigate]);


  useEffect(() => {
    function onConnect() {
      console.log('conecou no socket')
      setIsConnected(true);
    }

    function onDisconnect() {
      setIsConnected(false);
    }

    function onFooEvent(value: any) {
      console.log('receiveMessage', value)
      NotificationManager.success(value.message);

      setFooEvents((previous: any) => [...previous, value.message]);
    }
    /* function onUpdateLocation(value: any) {
      console.log('receiveMessage onUpdateLocation', value)
      //NotificationManager.info(value.message);
      updateUserPosition(value)
    } */

    socket.on('connect', onConnect);
    socket.on('disconnect', onDisconnect);
    socket.on('receiveMessage', onFooEvent);
    //socket.on('receiveUpdatePosition', onUpdateLocation);
    socket.connect();
    return () => {
      socket.off('connect', onConnect);
      socket.off('disconnect', onDisconnect);
      socket.off('receiveMessage', onFooEvent);
      //socket.off('receiveUpdatePosition', onUpdateLocation);
    };
  }, []);

  const drawerWidth = 240;

  return (
    <div className="app">
      <NotificationContainer />
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <ChatProvider>
          <Header />
          {/* <div className='bgcontent'>
            <img  width={'100%'} src={bg} alt="bg_wescout" />
          </div> */}
          <div className="main-content">

            {/* Menu Icon moved to Header */}

            <Routes>
              {isLogged && user?.name && user.confirmed ? (
                <Route path="/" element={user.role == "admin" ? <HomePage /> : <ScoutersPage />} />
              ) : null}
              {isLogged && user?.name && !user.confirmed ? (
                <Route path="/" element={<CodePage />} />
              ) : null}
              <Route path="/referral" element={<ReferralPage />} />
              <Route path="/password" element={<PasswordPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/invoices" element={<InvoicesPage />} />
              <Route path="/location" element={<LocationPage />} />
              <Route path="/signup" element={<SignUpPage />} />
              <Route path="/signup/:type" element={<SignUpPage />} />
              <Route path="/usuario" element={<UsuarioPage />} />
              <Route path="/code" element={<CodePage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/companies" element={<CompaniesPage />} />
              <Route path="/categories" element={<CategoriasPage />} />
              <Route path="/carrerguide" element={<CarrerGuidePage />} />
              <Route path="/empresa" element={<EmpresaPerfilPage />} />
              <Route path="/users" element={<UsuariosPage />} />
              <Route path="/account" element={<AccountPage />} />
              <Route path="/produtos" element={<ProdutosPage />} />
              <Route path="/scouter" element={<ScoutersPage />} />
              <Route path="/scout" element={<ScoutPage />} />
              <Route path="/getpremium" element={<GetpremiumPage />} />
              <Route path="/logs" element={<LogsPage />} />
              <Route path="/scoutme" element={<ScoutMePage />} />
              <Route path="/jobboard" element={<JobboardPage />} />
              <Route path="/jobboardadm" element={<JobboardAdmPage />} />
              <Route path="/aivisaguide" element={<AiVisaGuidePage />} />
              <Route path="/airesumefeedback" element={<AiResumeFeedback />} />
              <Route path="/aiinterviewsimulation" element={<AiInterviewSimulation />} />
              <Route path="/map" element={<MapaPage />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/notifications" element={<NotificationsPage />} />
              <Route path="/scoutingpool" element={<ScoutingPoolPage />} />
              <Route path="/favorites" element={<FavoritesPage />} />
              <Route path="/waitlist" element={<WaitListPage />} />
            </Routes>

            {isLogged && (
              <>
                <ChatFloatingButton />
                <ChatList />
                <ChatWindow />
              </>
            )}

          </div>

          <Footer />
        </ChatProvider>
      </LocalizationProvider>
    </div>
  );
}

const mapStateToProps = (state: any) => ({
  isLogged: state.auth.isLogged,
  user: state.user.user
});

const mapDispatchToProps = {
  updateUserPosition,
  setUser,
  setImageProfile
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(App);